import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import FactsStrip from "@/components/site/FactsStrip";
import Portfolio from "@/components/site/Portfolio";
import ServicesOverview from "@/components/site/ServicesOverview";
import HowItFits from "@/components/site/HowItFits";
import Portal from "@/components/site/Portal";
import Pricing from "@/components/site/Pricing";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import ClosingCTA from "@/components/site/ClosingCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";
import ScrollProgress from "@/components/site/ScrollProgress";
import useSeo from "@/hooks/useSeo";
import { HOME_FAQS, faqJsonLd } from "@/lib/faqs";

const HOME_JSON_LD = faqJsonLd();

export default function LandingPage() {
  useSeo({
    title: "Websites for Local Service Businesses | WebJesters",
    description:
      "Websites built, hosted and managed for local service businesses — $499 build + $79/mo. Plus Google Business Profile setup and Local Visibility posting.",
    path: "/",
    jsonLd: HOME_JSON_LD,
  });
  return (
    <main id="main-content" data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <FactsStrip />
      <ServicesOverview />
      <HowItFits />
      <Portfolio />
      <Portal />
      <Pricing />
      <About />
      <FAQ
        items={HOME_FAQS}
        showMore
        tone="light"
        intro="Straight answers on pricing, what's included, and how our services fit together."
      />
      <ClosingCTA />
      <Contact />
      <Footer />
      <StickyMobileCTA />
      <ScrollProgress />
    </main>
  );
}
